import { useState } from 'react';

export default function SaveWorkspaceModal({ paperCount, onSave, onClose }) {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    await onSave(name.trim());
    setSaving(false);
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
      <div
        className="bg-white rounded-xl w-full max-w-sm p-6"
        style={{ boxShadow: 'rgba(0,0,0,0.08) 0px 0px 0px 1px, rgba(0,0,0,0.04) 0px 8px 24px' }}
      >
        <h2 className="font-semibold text-[#171717] text-base mb-1" style={{ letterSpacing: '-0.32px' }}>
          Save Workspace
        </h2>
        <p className="text-sm text-[#808080] mb-4">
          {paperCount} paper{paperCount !== 1 ? 's' : ''} will be saved.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            autoFocus
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. CRISPR knockout project"
            className="w-full rounded-md px-3 py-2 text-sm text-[#171717] placeholder-[#808080] bg-white focus:outline-none focus:ring-2 focus:ring-[#0a72ef]"
            style={{ boxShadow: 'rgba(0,0,0,0.08) 0px 0px 0px 1px' }}
          />
          <div className="flex gap-2">
            <button
              type="submit"
              disabled={!name.trim() || saving}
              className="flex-1 py-2 bg-[#171717] text-white rounded-md text-sm font-medium hover:bg-[#2e2e2e] disabled:opacity-50 transition-colors"
            >
              {saving ? 'Saving...' : 'Save'}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="flex-1 py-2 text-sm font-medium text-[#4d4d4d] rounded-md hover:text-[#171717] transition-colors"
              style={{ boxShadow: 'rgba(0,0,0,0.08) 0px 0px 0px 1px' }}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
